import React from 'react';
import SorterBandTable from '../components/Reports/SorterBandTable';

export default function ReportsPage(props) {
  const [time, setTime] = React.useState(new Date());
  const [shift, setShift] = React.useState("AM");
  const { sessionId } = props;

  React.useEffect(() => {
    const interval = setInterval(() => {
      let now = new Date();
      setTime(now);
      let hour = now.getHours();
      let shift = (hour >= 7 && hour < 15) ? "AM" : (hour >= 15 && hour < 23) ? "PM" : "Nocturno";
      setShift(shift)

    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='d-flex align-items-center justify-text-center flex-column' style={{ marginTop: "80px", height: "100%" }}>
      <h2>{time.toLocaleDateString()} {time.toLocaleTimeString()}</h2>
      <h2>Horario: {shift}</h2>
      <div className='d-flex align-items-center justify-content-center flex-wrap' style={{ height: "100%" }}>
        <SorterBandTable sorterId="65e21d7d12528c030db80ddd" bandId="660c571e717976563fab160a" sessionId={sessionId} />
        <SorterBandTable sorterId="66216ac5fbc3ed555728789f" bandId="6634ec64f686183eba201430" sessionId={sessionId} />
        <SorterBandTable sorterId="6623f0dc0a0e21087de9ff9b" bandId="6634ec77f686183eba201431" sessionId={sessionId} />
        <SorterBandTable sorterId="6623f2070a0e21087de9ff9c" bandId="6634ec82f686183eba201432" sessionId={sessionId} />
      </div>
    </div>
  );
}

